<template>
  <ArtisanGrid
  ref="project"
  metaKey="OpProjectInfo"
  :confirmAfter="loadTreeData"
  :delRowAfter="loadTreeData"
  :leftOption="{ width: '20%' }"
  >
    <template #isLimosis="{ row }">
      <el-switch
      v-model="row.isLimosis"
      active-color="#13ce66"
      @change="change(row)"
      ></el-switch>
    </template>
    <template #leftAside>
      <artisan-group style="height: 100%; border: none; overflow-y: auto">
        <div slot="header">
          <span>院区科室</span>
        </div>
        <el-tree
        :data="treeData"
        node-key="id"
        ref="tree"
        :default-expanded-keys="expandedKeys"
        highlight-current
        :props="defaultProps"
        :expand-on-click-node="false"
        @current-change="treeChange"
        >
        </el-tree>
      </artisan-group>
    </template>
    <template #duration="{ row }">
      <el-input-number
      style="width: 100%"
      v-model="row.duration"
      :controls="false"
      :min="0"
      :max="60"
      size="mini"
      @change="change(row)"
      ></el-input-number>
    </template>
  </ArtisanGrid>
</template>

<script>
  import { getHosDepts } from "@/api/op/dept";
  import { buildTree } from "@/util/util";
  import { editProject } from "@/api/op/project";
  export default {
    data() {
      return {
        treeData: [],
        parts: [],
        expandedKeys: [],
        defaultProps: {
          children: "children",
          label: "name",
        },
      };
    },
    created() {
      getHosDepts().then((res) => {
        let data = res.data.data;
        let root = {
          id: "",
          name: "所有",
          children: [],
        };
        data.forEach((item) => {
          const deptTree = buildTree(item.opDepts);
          this.expandedKeys.push("hos" + item.id);
          root.children.push({
            id: "hos" + item.id,
            name: item.name,
            hosId: item.id,
            isHos: true,
            children: deptTree,
          });
        });
        this.treeData.push(root);
      });
    },
    methods: {
      change(row) {
        editProject(row).then((res) => {});
      },
      loadTreeData() {
        this.$refs.project.reloadDicByCol("parentId");
      },
      treeChange(data) {
        if (data.id) {
          if (data.isHos) {
            this.$refs.project.reload({
              hosId: data.hosId,
              deptId: "",
            });
          } else {
            this.$refs.project.reload({
              hosId: data.hosId,
              deptId: data.id,
            });
          }
        } else {
          this.$refs.project.reload({ hosId: "", deptId: "" });
        }
      },
    },
  };
</script>

<style></style>
